import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import FullNameInput from './FullNameInput';
import EmailInput from './EmailInput';

import Button from '../../Button';
import TwoGroup from '../../TwoGroup';
import ButtonGroup from './ButtonGroup';
import FormSectionContainer from './FormSectionContainer';
import SmallFormGroup from './SmallFormGroup';

import { validatePersonalDetails } from './validations.js';

import GetUpdatesCheckbox from '../../Widget/GetUpdatesCheckbox';
import LegalInfo from '../../Widget/LegalInfo';

import { getCachedFullName } from '../../../utils/formCaching/helpers';

const FormGroupWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin: 0 -0.5em;

    > div {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin: 0 0.5em;
    }
`;

const MobileStep1Form = props => (
    <FormSectionContainer onSubmit={props.handleSubmit}>
        <SmallFormGroup>
            <FullNameInput autoFocus={false} />
        </SmallFormGroup>
        <SmallFormGroup marginBottom={'1em'}>
            <EmailInput />
        </SmallFormGroup>
        <SmallFormGroup>
            <FormGroupWrapper>
                <GetUpdatesCheckbox />
                <LegalInfo align="right" />
            </FormGroupWrapper>
        </SmallFormGroup>
        <ButtonGroup>
            <TwoGroup>
                <Button label="Back" onClick={props.onBackToAmount} />
                <Button
                    primary={true}
                    label={`Next`}
                    type="submit"
                    disabled={props.invalid || props.submitting}
                />
            </TwoGroup>
        </ButtonGroup>
    </FormSectionContainer>
);

MobileStep1Form.propTypes = {
    onBackToAmount: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired
};

export default compose(
    connect(state => ({
        initialValues: {
            getUpdates: true,
            fullName: getCachedFullName(state),
            email: state.cachedFormData.email || ''
        }
    })),
    reduxForm({
        form: 'donationDetailsFormStep1',
        destroyOnUnmount: false,
        validate: validatePersonalDetails
    })
)(MobileStep1Form);



// WEBPACK FOOTER //
// ./src/components/Donation/Form/MobileStep1Form.jsx